







import {Vue, Component} from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

export const TAB_KEYS = {
  introduction: 'MALLS_AND_COMPANY', // 쇼핑몰, 회사소개
  access: 'TERMS', // 이용약관
  'e-commerce': 'ELECTRONIC_FINANCIAL', // 전자금융거래이용약관
  'personal-info': 'PERSONAL_INFORMATION', // 개인정보처리방침
  collection: 'PERSONAL_COLLECTION', // 개인정보 수집 동의 항목
  withdrawal: 'USE_LEAVE', // 이용/탈퇴
  AUTO_APPROVAL: 'AUTO_APPROVAL', // 정기결제(배송) 이용약관
} as const;

@Component({
  components: {
    AdminIframe,
    PageTitle
  }
}) 
export default class TermsIframe extends Vue {
  private remoteSrc = '';


  private setRemoteSrc() {
    const pathSegments = this.$route.path.split('/')?.filter(Boolean); 
    const tabPathName = (pathSegments?.at(-1) ?? 'introduction') as keyof typeof TAB_KEYS; 

    const queryTab = (typeof (this.$route.query.tab ?? '' ) === 'string' ? this.$route.query.tab : this.$route.query.tab.toString()) as string;
    /**
     * focusedTab 
     * path의 마지막 segment를 기준으로 tab을 선택한다.
     * query내 tab이 있으면 우선순위를 바꿈
     */
    const focusedTab = TAB_KEYS[tabPathName] === queryTab ? TAB_KEYS[tabPathName] : (queryTab || TAB_KEYS[tabPathName]);

    const queryObject = { ...this.$route.query, tab: focusedTab, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/configuration/basic/terms?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
